<template>
    <!-- Testimonials -->
    <section class="testimonials py-24 overflow-hidden">
        <div class="container">
            <!-- Sektionstitel -->
            <h2 class="landing-h2 lg:w-[50%]">
                <template v-for="currentBlok in blok.headline">
                    <span :class="[currentBlok.hasColorGradient ? 'gradient-dark' : '']">{{ currentBlok.text }}&nbsp;</span> 
                </template>
            </h2>
            <!-- TrustBox widget - Micro Combo
            <div class="trustpilot-widget" data-locale="de-DE" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="6247111df732c01f03719de0" data-style-height="20px" data-style-width="100%">
                <a href="https://de.trustpilot.com/review/humandesignclub.com" target="_blank" rel="noopener">Trustpilot</a>
            </div>
            End TrustBox widget -->

            <!-- Slider Wrapper -->
            <div class="relative">

                <!-- Arrows oben rechts -->
                <button
                    class="absolute -top-24 right-16 bg-black text-white rounded-full p-2 z-10 mr-4"
                    @click="goToTestimonial((currentTestimonial - 1 + testimonials.length) % testimonials.length)">
                    <font-awesome-icon class="size-8" :icon="['fasr', 'chevron-left']" />
                </button>
                <button
                    class="absolute -top-24 right-4 bg-black text-white rounded-full p-2 z-10"
                    @click="goToTestimonial((currentTestimonial + 1) % testimonials.length)">
                    <font-awesome-icon class="size-8" :icon="['fasr', 'chevron-right']" />
                </button>

            <!-- Slides Container -->
            <div class="overflow-visible">
                <div
                class="flex transition-transform duration-500 space-x-8"
                :style="{ transform: `translateX(-${offsetPercent}%)` }"
                >
                <div class="flex-shrink-0 w-full lg:w-1/3" v-for="(item, idx) in testimonials" :key="idx">
                    <div class="bg-white rounded-3xl shadow-lg p-8 flex flex-col h-full">
                    <!-- Icon oben links -->
                    <div class="mb-4">
                        <font-awesome-icon class="w-5 h-5" :icon="['fasr', 'circle-check']"/>
                    </div>
                    <!-- Text -->
                    <h3 class="font-bold text-lg mb-2">{{ item.title }}</h3>
                    <p class="text-sm text-gray-700 flex-1">
                        {{ item.text }}
                    </p>
                    <!-- Autor-Info unten -->
                    <div class="mt-6 flex items-center">
                        <img :src="item.avatar" alt="Avatar" class="w-12 h-12 rounded-full mr-4" />
                        <div>
                        <div class="font-semibold">{{ item.name }}</div>
                        <div class="text-xs text-gray-500">{{ item.date }}</div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    defineProps({ blok: Object })

// Testimonial Slider

import { ref, onMounted, onUnmounted, computed } from 'vue'
const testimonials = ref([
  {
    title: 'Ein großartiger Chartrechner – absolut empfehlenswert!',
    text: 'Coisar hat mir geholfen, meine Stärken und Herausforderungen klar zu erkennen. Die Analysen sind extrem tiefgehend und zugleich leicht verständlich.',
    name: 'Jessica Mergel',
    date: '28. November 2024',
    avatar: '/testimonial-jens.jpg'
  },
  {
    title: 'Zweifellos eines der besten Tools, die ich je genutzt habe.',
    text: 'Die Benutzeroberfläche ist intuitiv, und die Ergebnisse sind präzise. Ich konnte sofort meine Potenziale nutzen und habe großes Vertrauen gewonnen.',
    name: 'Birgit Mutz',
    date: '28. November 2024',
    avatar: '/testimonial-jens.jpg'
  },
  {
    title: 'Human Design Chart Rechner der nächsten Generation',
    text: 'Coisar hat mich begeistert! Die Kombination aus tiefgreifender Analyse und modernem Design macht es unschlagbar.',
    name: 'Christina Heitkötter',
    date: '28. November 2024',
    avatar: '/testimonial-jens.jpg'
  },
    {
    title: 'Ein großartiger Chartrechner – absolut empfehlenswert!',
    text: 'Coisar hat mir geholfen, meine Stärken und Herausforderungen klar zu erkennen. Die Analysen sind extrem tiefgehend und zugleich leicht verständlich.',
    name: 'Jessica Mergel',
    date: '28. November 2024',
    avatar: '/testimonial-jens.jpg'
  },
  {
    title: 'Zweifellos eines der besten Tools, die ich je genutzt habe.',
    text: 'Die Benutzeroberfläche ist intuitiv, und die Ergebnisse sind präzise. Ich konnte sofort meine Potenziale nutzen und habe großes Vertrauen gewonnen.',
    name: 'Birgit Mutz',
    date: '28. November 2024',
    avatar: '/testimonial-jens.jpg'
  },
  {
    title: 'Human Design Chart Rechner der nächsten Generation',
    text: 'Coisar hat mich begeistert! Die Kombination aus tiefgreifender Analyse und modernem Design macht es unschlagbar.',
    name: 'Christina Heitkötter',
    date: '28. November 2024',
    avatar: '/testimonial-jens.jpg'
  }
]);
const currentTestimonial = ref(0);

const goToTestimonial = (index) => {
  currentTestimonial.value = index;
}

// Für Desktop: 3 Slides pro View; für Mobile: 1 Slide pro View
const isDesktop = ref(window.innerWidth >= 1024);
window.addEventListener('resize', () => {
  isDesktop.value = window.innerWidth >= 1024;
});
// Berechne, um wieviel Prozent verschoben werden muss
const offsetPercent = computed(() => {
  // Wenn Desktop, verschiebe um 100/3 pro Index (ca. 33.333%)
  return isDesktop.value
    ? (currentTestimonial.value * (100 / 3))
    : (currentTestimonial.value * 100);
});

let autoplayInterval;
onMounted(() => {
  autoplayInterval = setInterval(() => {
    currentTestimonial.value = (currentTestimonial.value + 1) % testimonials.value.length;
  }, 5000);
});
onUnmounted(() => {
  clearInterval(autoplayInterval);
});
</script>